import React, { FC, useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import styles from './BurgerMenuStyle.module.scss'
import { CloseHeaderIcon } from 'shared/assets/icons'
import { useBurgerMenu } from 'context/BurgerMenuContext/BurgerMenuContext'
import CategoryList from '../CategoryDropdown/test'
import { SupplierContext } from 'context/SupplierContext'
import { useAppSelector } from 'libraries/redux'
import { CategoriesSelectors } from 'store/category/selectors'
import { useFetchCategoriesListQuery } from '../../../../entities/Categories/api/supplier/apiCategoriesSlice'
import { Link } from 'react-router-dom'

interface BurgerMenuProps {
  isSupplier: boolean
  renderMenuListForSuppliers: React.ReactNode
  renderMenuList: React.ReactNode
  isTabletL: boolean
}

const BurgerMenu: FC<BurgerMenuProps> = ({ isSupplier, renderMenuListForSuppliers, renderMenuList }) => {
  const { isOpen, closeMenu } = useBurgerMenu()
  const [isVisible, setIsVisible] = useState(false)

  const { is_supplier } = useContext(SupplierContext)
  const { data: categoriesList } = useAppSelector(CategoriesSelectors.categoriesList)

  const customerId = Number(window.config.CUSTOMER_ID)
  const categoryId = Number(window.config.CATEGORY_ID)
  const { data: fetchedProductsCategories, isLoading: categoriesLoading } = useFetchCategoriesListQuery(
    {
      customer_id: customerId,
      parent_id: categoryId,
      is_supplier: is_supplier,
    },
    { skip: !is_supplier || !customerId }
  )

  // Fallback запрос без filter_parent_id если первый запрос вернул пустой массив
  const shouldFallback = is_supplier && !categoriesLoading && fetchedProductsCategories?.data?.length === 0
  const { data: fallbackCategories } = useFetchCategoriesListQuery(
    {
      customer_id: customerId,
      parent_id: null,
      is_supplier: is_supplier,
    },
    { skip: !shouldFallback }
  )

  const categoriesToRender = is_supplier
    ? (fetchedProductsCategories?.data?.length > 0 ? fetchedProductsCategories?.data : fallbackCategories?.data)
    : categoriesList

  // новое состояние для переключения вкладок
  const [activeTab, setActiveTab] = useState<'shop' | 'about'>('shop')

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true)
      document.body.style.overflow = 'hidden'
    } else {
      const timeout = setTimeout(() => {
        setIsVisible(false)
        document.body.style.overflow = ''
      }, 300) // должно совпадать с transition

      return () => clearTimeout(timeout)
    }
  }, [isOpen])

  return (
    <div className={classNames(styles.burgerMenu, { [styles.active]: isOpen }, { [styles.hidden]: !isOpen })}>
      <div className={styles.header}>
        <h1 className={styles.menuTitle}>МЕНЮ</h1>
        <div className={styles.closeButton} onClick={closeMenu}>
          <CloseHeaderIcon />
        </div>
      </div>

      {/* Табы */}
      <div className={styles.tabs}>
        <button
          className={classNames(styles.tab, { [styles.activeTab]: activeTab === 'shop' })}
          onClick={() => setActiveTab('shop')}
        >
          Магазин
        </button>
        <button
          className={classNames(styles.tab, { [styles.activeTab]: activeTab === 'about' })}
          onClick={() => setActiveTab('about')}
        >
          Інфо
        </button>
      </div>

      {/* Контент табов */}
      <div className={styles.tabContent}>
        {activeTab === 'shop' ? (
          <nav className={styles.nav} onClick={closeMenu}>
            <CategoryList categories={categoriesToRender} onClose={closeMenu} />
          </nav>
        ) : (
          <div className={styles.nav}>
            <Link className={styles.categoryTitle} to='/agreement' onClick={closeMenu}>
              <span className={styles.categoryTitle_text}>Про нас</span>
            </Link>
            <Link className={styles.categoryTitle} to='/agreement' onClick={closeMenu}>
              <span className={styles.categoryTitle_text}>Контакти</span>
            </Link>

            {/* <h2 className={styles.categoryTitle}>Доставка</h2>
            <h2 className={styles.categoryTitle}>Оплата</h2>
            <h2 className={styles.categoryTitle}>Повернення та обмін</h2> */}
          </div>
        )}
      </div>
    </div>
  )
}

export default BurgerMenu
